<template>
  <div class="vacations-hourly">
    <template v-if="loaded">
      <Table>
        <thead>
          <tr>
            <th v-if="signableVacationsHourly.length > 0 && activeCompany !== 'КЦМ 2000'" style="width: 40px">
              <input
                type="checkbox"
                @change="toggleSelectAll"
                :checked="
                  selectedVacationHourlyIds.length === signableVacationsHourly.length &&
                  signableVacationsHourly.length > 0
                "
                @click.stop
              />
            </th>
            <th>№</th>
            <th>ДАТА</th>
            <th>ВИД ОТСЪСТВИЕ</th>
            <th>СЛ. НОМЕР</th>
            <th>ЗА СЛУЖИТЕЛ</th>
            <th>ПРЯК РЪК-Л</th>
            <th>ДАТА/ПЕРИОД ОТСЪСТВИЕ</th>
            <th>ЧАС ОТ</th>
            <th>ЧАС ДО</th>
            <th>
              <div class="status" :class="{ active: statusDropdown }">
                <span class="status__toggle" @click="statusDropdown = !statusDropdown">
                  СТАТУС <span class="icon">H</span>
                </span>
                <div class="status__dropdown" v-if="statusDropdown">
                  <template v-if="activeCompany === 'КЦМ 2000'">
                    <p :class="{ active: $route.query.stage === '' }" @click="selectStage('')">Покажи всички</p>
                    <p :class="{ active: $route.query.stage === 'finished' }" @click="selectStage('finished')">
                      Одобрена
                    </p>
                    <p :class="{ active: $route.query.stage === 'waiting' }" @click="selectStage('waiting')">Чакаща</p>
                    <p :class="{ active: $route.query.stage === 'annulled' }" @click="selectStage('annulled')">
                      Анулирана
                    </p>
                  </template>
                  <template v-else>
                    <p :class="{ active: !$route.query.stage }" @click="selectStage('')">Покажи всички</p>
                    <p :class="{ active: $route.query.stage === 'waiting' }" @click="selectStage('waiting')">
                      Чакащи за одобрение
                    </p>
                    <p
                      :class="{ active: $route.query.stage === 'supervisorFirst' }"
                      @click="selectStage('supervisorFirst')"
                    >
                      Към пряк Рък-л
                    </p>
                    <p
                      :class="{
                        active: $route.query.stage === 'supervisorSecond',
                      }"
                      @click="selectStage('supervisorSecond')"
                    >
                      Към Рък-л ЦП/ОП/ТУ/Цех/Отдел
                    </p>
                    <p :class="{ active: $route.query.stage === 'hr' }" @click="selectStage('hr')">Към ЧР</p>
                    <p :class="{ active: $route.query.stage === 'annulled' }" @click="selectStage('annulled')">
                      Анулирана
                    </p>
                    <p :class="{ active: $route.query.stage === 'denied' }" @click="selectStage('denied')">Отказана</p>
                    <p :class="{ active: $route.query.stage === 'approved' }" @click="selectStage('approved')">
                      Одобрена
                    </p>
                  </template>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="vacationsHourly.length">
          <tr v-for="v of vacationsHourly" :key="v._id" @click="openVacationHourly(v._id)">
            <td v-if="signableVacationsHourly.length > 0 && activeCompany !== 'КЦМ 2000'" @click.stop>
              <input
                v-if="canSign(v)"
                type="checkbox"
                :checked="selectedVacationHourlyIds.includes(v._id)"
                @change="toggleSelection(v._id)"
              />
            </td>
            <td>{{ v.number ? `ПО${v.number}` : '' }}</td>
            <td>{{ v.dateOfSigning | formatDate }}</td>
            <td>
              <div class="reports-status">
                <p>
                  {{ v.template[`typeName${v.type}`] }}
                </p>
                <section
                  v-if="v.type === '0016' && v.reportsStatus && v.finalizedAt && !v.annulled"
                  @click.stop="openReportPeriodModal(v)"
                  :class="v.reportsStatus.class"
                >
                  <span class="icon">p</span>
                  <span>{{ v.reportsStatus.name }}</span>
                </section>
              </div>
            </td>
            <td>
              {{ v.userNumber }}
            </td>
            <td>{{ v.userName }}</td>
            <td>{{ getSupervisorFirstDisplayName(v) }}</td>
            <template
              v-if="
                v.type === '0012' ||
                (v.type === '0016' && !(activeCompany === 'КЦМ 2000' && v.homeOfficeByHours)) ||
                v.type === '0045' ||
                v.type === '0046'
              "
            >
              <td>
                <span>{{ v.dateFrom | formatDate }}</span>
                <span> - {{ v.dateTo | formatDate }}</span>
              </td>
              <td></td>
              <td></td>
            </template>
            <template v-else>
              <td>
                <span>{{ v.dateFrom | formatDate }}</span>
              </td>
              <td>{{ v.hourFrom }}</td>
              <td>{{ v.hourTo }}</td>
            </template>
            <td>
              <template v-if="activeCompany === 'КЦМ 2000'">
                <img src="@/assets/img/stages/mini-annulled.svg" v-if="v.annulled" />
                <img src="@/assets/img/stages/mini-finalized.svg" v-else-if="v.finalizedAt" />
                <img src="@/assets/img/stages/mini-waiting.svg" v-else />
              </template>
              <template v-else>
                <img src="@/assets/img/stages/ss-a.svg" v-if="v.annulled" />

                <template v-else-if="v.needsSecondConfirmation">
                  <img src="@/assets/img/stages/ss-c.svg" v-if="!v.allowedBySupervisorSecond" />
                  <template v-else-if="v.type === '0030' || v.type === '0025'">
                    <img src="@/assets/img/stages/ss-4.svg" v-if="v.finalizedAt" />
                    <img src="@/assets/img/stages/ss-3.svg" v-else-if="v.signatures.supervisorSecond" />
                    <img src="@/assets/img/stages/ss-2.svg" v-else-if="v.signatures.supervisorFirst" />
                    <img src="@/assets/img/stages/ss-1.svg" v-else />
                  </template>
                  <template v-else-if="v.type === '0012'">
                    <img src="@/assets/img/stages/ssa-3.svg" v-if="v.finalizedAt" />
                    <img
                      src="@/assets/img/stages/ssa-2.svg"
                      v-else-if="v.signatures.supervisorFirst && v.signatures.user"
                    />
                    <img src="@/assets/img/stages/ssa-1.svg" v-else />
                  </template>
                  <template v-else-if="v.type === '0020'">
                    <img src="@/assets/img/stages/ssa-3.svg" v-if="v.finalizedAt" />
                    <img src="@/assets/img/stages/ssa-2.svg" v-else-if="v.signatures.supervisorSecond" />
                    <img src="@/assets/img/stages/ssa-1.svg" v-else />
                  </template>
                  <template v-else-if="v.type === '0045'">
                    <img src="@/assets/img/stages/s2-2-s.svg" v-if="v.finalizedAt" />
                    <img src="@/assets/img/stages/s2-1-s.svg" v-else />
                  </template>
                </template>
                <template v-else-if="activeCompany === 'КЦМ 2000'">
                  <template v-if="v.type === '0016' || v.type === '0030'">
                    <img src="@/assets/img/stages/s2-2-s.svg" v-if="v.finalizedAt" />
                    <img src="@/assets/img/stages/s2-1-s.svg" v-else-if="v.signatures.user" />
                    <img src="@/assets/img/stages/s2-0-s.svg" v-else />
                  </template>
                  <template v-else>
                    <img src="@/assets/img/stages/s1-1-s.svg" v-if="v.finalizedAt" />
                    <img src="@/assets/img/stages/s1-0-s.svg" v-else />
                  </template>
                </template>
                <template v-else-if="v.type === '0030' || v.type === '0025'">
                  <img src="@/assets/img/stages/ssa-3.svg" v-if="v.finalizedAt" />
                  <img src="@/assets/img/stages/ssa-2.svg" v-else-if="v.signatures.supervisorFirst" />
                  <img src="@/assets/img/stages/ssa-1.svg" v-else />
                </template>
                <template v-else-if="v.type === '0012' || v.type === '0020' || v.type === '0016' || v.type === '0019'">
                  <img src="@/assets/img/stages/s2-2-s.svg" v-if="v.finalizedAt" />
                  <img src="@/assets/img/stages/s2-1-s.svg" v-else />
                </template>
                <template v-else-if="v.type === '0045' || v.type === '0046'">
                  <img src="@/assets/img/stages/s1-1-s.svg" />
                </template>
              </template>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-if="$route.query.search">
            <td colspan="10">
              Няма резултати от търсенето. Проверете дали периода, името, или служебния номер са коректни.
            </td>
          </tr>
          <tr v-else>
            <td colspan="10">
              Няма резултати за периода
              <span v-if="$route.query.type">от този тип отпуск</span>
            </td>
          </tr>
        </tbody>
      </Table>
      <Pagination :total="total" :size="size" />

      <ReportsPeriodModal
        v-if="isReportModalOpen"
        :reports="selectedVh.reports"
        :vh="selectedVh"
        @getReports="getWorkDays()"
        @close="closeReportPeriodModal"
      />

      <!-- Bulk Signature Modal -->
      <SignatureModal
        v-if="bulkSignatureModal"
        @signed="handleBulkSign"
        @close="bulkSignatureModal = false"
        :director="selectedVacationHourlyIds.length"
        :loading="bulkSigning"
      />
    </template>
    <p v-else>Зареждане...</p>
  </div>
</template>

<script>
import Table from '@/components/Table';
import Pagination from '@/components/Pagination';
import ReportsPeriodModal from '@/components/ReportsPeriodModal';
import SignatureModal from '@/components/signature/SignatureModal';
import { mapGetters } from 'vuex';
import { KCM_AD_LIKE_COMPANIES, METALURG21_COMPANY, isCompanyIn } from '@/common/companies';
export default {
  components: {
    Table,
    Pagination,
    ReportsPeriodModal,
    SignatureModal,
  },
  computed: {
    ...mapGetters(['activeCompany', 'currentUser']),
    uploads() {
      return process.env.VUE_APP_UPLOADS_URI;
    },
    signableVacationsHourly() {
      return this.vacationsHourly.filter((vh) => this.canSign(vh));
    },
    hasKcmAdLikeFeatures() {
      return isCompanyIn(KCM_AD_LIKE_COMPANIES, this.activeCompany);
    },
  },
  data() {
    return {
      total: 0,
      size: 20,
      vacationsHourly: [],
      loaded: false,
      statusDropdown: false,
      isReportModalOpen: false,
      selectedVh: '',
      selectedVacationHourlyIds: [],
      bulkSignatureModal: false,
      bulkSigning: false,
    };
  },
  watch: {
    $route: {
      handler: 'getVacationsHourly',
      immediate: true,
    },
    selectedVacationHourlyIds(newVal) {
      this.$store.commit('SET_SELECTED_VACATIONS_HOURLY_COUNT', newVal.length);
    },
  },
  methods: {
    isApproverDelegateFor(approver) {
      const approverId = approver && approver._id ? approver._id : approver;
      return !!approverId && Array.isArray(this.currentUser.approverDelegateForIds) && this.currentUser.approverDelegateForIds.includes(approverId);
    },
    getSupervisorFirstDisplayName(vh) {
      if (vh?.supervisorFirstSignedBy?.name) {
        return vh.supervisorFirstSignedBy.name;
      }

      return vh?.supervisorFirst?.name || '';
    },
    canSign(vh) {
      if (!this.currentUser || vh.finalizedAt || vh.annulled || vh.company === 'КЦМ 2000') {
        return false;
      }

      const { admin, hr } = this.currentUser.roles || {};
      if (admin) return true; // admin can sign all

      const userId = String(this.currentUser._id);

      const isOwn = userId === vh.user._id;
      const isDelegate =
        this.isApproverDelegateFor(vh.supervisorFirst) ||
        (
        !!vh.user?.requireAdditionalApproverSignature &&
        String(vh.user?.additionalApprover?._id || vh.user?.additionalApprover || '') === userId
        ) ||
        (
        vh.company === METALURG21_COMPANY &&
        !!vh.user?.notifySecondManager &&
        !!this.currentUser.metalurg21SupervisorFirstDelegate
        );
      const isSupervisorFirst = vh.supervisorFirst._id === userId || isDelegate;
      const isSupervisorSecond = vh.supervisorSecond._id === userId || this.isApproverDelegateFor(vh.supervisorSecond);
      const sig = vh.signatures || {};


      const CHAINS = {
        '0030': ['user', 'supervisorFirst', 'supervisorSecond', 'hr'], // Заявление за отпуск част от деня
        '0025': ['user', 'supervisorFirst', 'supervisorSecond', 'hr'], // Служебна бележка част от деня
        '0020': ['supervisorFirst', 'supervisorSecond', 'hr'], // Компенсация част от деня
        '0012': ['user', 'supervisorFirst', 'supervisorSecond'],       // Служебна бележка за цял ден
        '0045': ['supervisorFirst', 'supervisorSecond'],               // Компенсация цял ден
        '0016': ['supervisorFirst', 'user'],                           // home office
      };

      let chain = CHAINS[vh.type];
      if (!chain) return false;

      if (!vh.needsSecondConfirmation) {
        chain = chain.filter((step) => step !== 'supervisorSecond');
      }

      // find the next required signature (first step in chain that is not signed yet)
      const nextStep = chain.find((step) => {
        if (step === 'user') return !sig.user;
        if (step === 'supervisorFirst') return !sig.supervisorFirst;
        if (step === 'supervisorSecond') return !sig.supervisorSecond;
        if (step === 'hr') return !vh.finalizedAt;
        return false;
      });

      if (!nextStep) return false;

      // allow signing only if current user matches the next step
      if (nextStep === 'user') return isOwn;
      if (nextStep === 'supervisorFirst') return isSupervisorFirst;
      if (nextStep === 'supervisorSecond') return isSupervisorSecond;
      if (nextStep === 'hr') return !!hr;

      return false;
    },
    toggleSelection(vacationHourlyId) {
      const index = this.selectedVacationHourlyIds.indexOf(vacationHourlyId);
      if (index > -1) {
        this.selectedVacationHourlyIds.splice(index, 1);
      } else {
        this.selectedVacationHourlyIds.push(vacationHourlyId);
      }
    },
    toggleSelectAll() {
      if (this.selectedVacationHourlyIds.length === this.signableVacationsHourly.length) {
        this.selectedVacationHourlyIds = [];
      } else {
        this.selectedVacationHourlyIds = this.signableVacationsHourly.map((vh) => vh._id);
      }
    },
    openBulkSignatureModal() {
      if (this.selectedVacationHourlyIds.length === 0) {
        this.$snotify.warning('Моля изберете отсъствия за подписване');
        return;
      }
      this.bulkSignatureModal = true;
    },
    handleBulkSign(signature) {
      this.bulkSigning = true;

      // Determine action type based on first selected vacation
      const firstVh = this.vacationsHourly.find((vh) => vh._id === this.selectedVacationHourlyIds[0]);
      const isHR =
        this.currentUser.roles && this.currentUser.roles.hr && ['0020', '0019', '0025', '0030'].includes(firstVh.type);

      const payload = {
        vacationHourlyIds: this.selectedVacationHourlyIds,
        signature: signature,
      };

      // Default to allowing/approving when bulk signing
      if (isHR) {
        payload.allowedByHR = true;
      } else if (firstVh.needsSecondConfirmation) {
        payload.allowedBySupervisorSecond = true;
      }

      this.$apiService
        .put('/vacations-hourly/bulk-sign', payload)
        .then((res) => {
          this.bulkSignatureModal = false;
          this.bulkSigning = false;

          if (res.data.success && res.data.success.length > 0) {
            this.$snotify.success(res.data.message);

            // Show generated numbers
            if (res.data.success.some((s) => s.number)) {
              const numbers = res.data.success
                .filter((s) => s.number)
                .map((s) => `ПО${s.number}`)
                .join(', ');
              this.$snotify.info(`Генерирани номера: ${numbers}`);
            }
          }

          if (res.data.failed && res.data.failed.length > 0) {
            res.data.failed.forEach((f) => {
              this.$snotify.error(`${f.reason}`);
            });
          }

          // Reset selection and refresh
          this.selectedVacationHourlyIds = [];
          this.getVacationsHourly();
        })
        .catch((err) => {
          this.bulkSigning = false;
          console.error(err);
          if (err.response && err.response.data && err.response.data.message) {
            this.$snotify.error(err.response.data.message);
          } else {
            this.$snotify.error('Грешка при групово подписване');
          }
        });
    },
    // gets reportsStatus of vacation hourlies
    async getWorkDays() {
      let promises = [];

      for (let vh of this.vacationsHourly) {
        if (vh.type === '0016' && vh.user) {
          promises.push(
            await new Promise((resolve) => {
              let url = `/reports?vacationHourly=${vh._id}`;
              if (vh.dateFrom && vh.dateTo) url += `&dateFrom=${vh.dateFrom}&dateTo=${vh.dateTo}`;

              this.$apiService
                .get(url)
                .then(async (res) => {
                  this.$set(vh, 'reports', res.data);

                  await new Promise((resolve) => {
                    this.$apiService
                      .get(`/days/period/${vh.dateFrom}/${vh.dateTo}`)
                      .then((res) => {
                        let workDays = [];
                        for (let i = 0; i < res.data.length; i++) {
                          let date = res.data[i];
                          if (this.hasKcmAdLikeFeatures && vh.shifts[i]) workDays.push(date);
                          if (this.activeCompany === 'КЦМ 2000' && !date.weekend) workDays.push(date);
                        }

                        let canReportStartDays = workDays.length ? workDays.filter((x) => x.canReportStart) : [];
                        const requiredDayKeys = new Set(
                          workDays.map((day) => this.getCalendarDayKey(day.fullDate)).filter(Boolean)
                        );
                        const reportedDayKeys = new Set(
                          vh.reports
                            .filter((report) => !report.draft)
                            .map((report) => this.getCalendarDayKey(report.createdOn))
                            .filter(Boolean)
                        );
                        const allWorkDaysReported =
                          requiredDayKeys.size > 0 &&
                          [...requiredDayKeys].every((dayKey) => reportedDayKeys.has(dayKey));

                        if (allWorkDaysReported) {
                          this.$set(vh, 'reportsStatus', { name: 'ЗАВЪРШЕН ОТЧЕТ', class: 'green' });
                        } else if (canReportStartDays.length === workDays.length) {
                          this.$set(vh, 'reportsStatus', { name: 'ОТЧИТАНЕ', class: 'blue' });
                        } else if (canReportStartDays.length !== workDays.length) {
                          this.$set(vh, 'reportsStatus', { name: 'ОТЧИТАНЕ', class: 'yellow' });
                        }
                        resolve();
                      })
                      .catch((err) => {
                        this.error = err.response.data.message;
                      });
                  });
                  resolve();
                })
                .catch((err) => {
                  this.error = err.response.data.message;
                });
            })
          );
        }
      }

      if (promises.length) {
        Promise.all(promises)
          .then(() => {})
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getCalendarDayKey(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return null;
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    openReportPeriodModal(vh) {
      this.selectedVh = vh;
      this.isReportModalOpen = true;
    },
    closeReportPeriodModal() {
      // this.getReports(this.selectedVh);
      this.isReportModalOpen = false;
      this.selectedVh = '';
    },
    selectStage(s) {
      const r = {
        path: this.$route.path,
        query: {
          ...this.$route.query,
          stage: s,
          t: new Date().getTime(),
        },
      };

      if (r.query.page) {
        delete r.query.page;
      }

      this.$router.push(r);
      this.statusDropdown = false;
    },
    getReports(vh) {
      if (vh.user) {
        let url = '/reports';
        url += `?creator=${vh.user._id}`;
        if (vh.dateFrom && vh.dateTo) url += `&dateFrom=${vh.dateFrom}&dateTo=${vh.dateTo}`;

        this.$apiService.get(url).then((res) => {
          this.$set(vh, 'reports', res.data);
        });
      }
    },
    getVacationsHourly() {
      this.loaded = true;
      this.loaded = false;
      this.vacationsHourly = [];
      this.statusDropdown = false;
      this.selectedVacationHourlyIds = [];
      let url = `/vacations-hourly?size=${this.size}&page=${this.$route.query.page || 1}`;
      if (this.$route.query.search) {
        url += `&search=${this.$route.query.search}`;
      }
      if (this.$route.query.type) {
        url += `&type=${this.$route.query.type}`;
      }
      if (this.$route.query.dateFrom && this.$route.query.dateTo) {
        url += `&dateFrom=${this.$route.query.dateFrom}&dateTo=${this.$route.query.dateTo}`;
      }
      if (!this.$route.query.dateFrom || !this.$route.query.dateTo) {
        return;
      }

      if (this.$route.query.stage) {
        url += `&stage=${this.$route.query.stage}`;
      }
      this.$apiService
        .get(url)
        .then((res) => {
          this.vacationsHourly = res.data.vacationsHourly;
          this.total = res.data.total;
        })
        .then(() => {
          if (this.vacationsHourly.length) {
            this.getWorkDays();
            // for (let vh of this.vacationsHourly) {
            //   if (vh.type === '0016') {
            // this.getReports(vh);
            // this.getWorkDays(vh);
            //   }
            // }
          }
          setTimeout(() => {
            this.loaded = true;
          }, 1000);
        });
    },
    openVacationHourly(v) {
      this.$router.push(`/vacations-hourly/${v}`);
    },
  },
  mounted() {
    this.$root.$on('bulk-sign-vacations-hourly', this.openBulkSignatureModal);
  },
  beforeDestroy() {
    this.$root.$off('bulk-sign-vacations-hourly', this.openBulkSignatureModal);
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
.vacations-hourly {
  height: 100%;
  padding: 10px;
  width: 100%;
}
.table-wrapper {
  min-height: 250px;
}
.table {
  tr {
    th:last-child,
    td:last-child {
      text-align: center;
      width: 1%;
      img {
        max-height: 25px;
        width: 87px;
      }
    }
  }
}
.reports-status {
  display: flex;
  gap: 10px;

  section {
    align-items: center;
    color: #e17800;
    display: flex;
    gap: 3px;
    &.blue {
      color: #35aadf;
    }
    &.red {
      color: #d80000;
    }
    &.green {
      color: #419500;
    }
    span {
      font-size: $px13;
      &:not(.icon) {
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}
.status {
  position: relative;
  .status__toggle {
    align-items: center;
    display: inline-flex;
    position: inherit;
    z-index: 2;
    @include hover();
    @include noselect();
    .icon {
      font-weight: 400;
      margin-left: 0.25rem;
      opacity: 0.3;
    }
  }
  &.active {
    .status__toggle {
      color: #fff;
    }
  }
  .status__dropdown {
    background-color: #7d95ac;
    border-radius: 10px;
    position: absolute;
    right: 0;
    top: -0.5rem;
    padding-top: 2rem;
    z-index: 1;
    p {
      color: #fff;
      cursor: pointer;
      padding: 2px 10px;
      text-align: right;
      white-space: nowrap;
      @include transition($transition);
      &.active,
      &:hover {
        background-color: rgba($color: #000, $alpha: 0.1);
      }
    }
  }
}
</style>
